import '@mantine/core/styles.layer.css';
import '@mantine/notifications/styles.layer.css';
import 'mantine-datatable/styles.layer.css';
import '@/app/app.scss';

import Routes from '@/app/Routes';

export default function Main() {
	return (
		<div className="root">
			<Routes />
		</div>
	);
}
